import { create } from '@/store'
import { devtools } from 'zustand/middleware'

export const useWorkflowStore = create(
  devtools(
    (set) => ({
      page: 1,
      pageSize: 10,
      setPage: (page) => set({ page, lastReloadTime: Date.now() }),
      setPageSize: (pageSize) => set({ pageSize, lastReloadTime: Date.now() }),
      lastReloadTime: Date.now(),
      resetLastReloadTime: () =>
        set({
          lastReloadTime: Date.now(),
          page: 1,
        }),
    }),
    { name: 'workflow-store' },
  ),
)
